export default {"src":"/_next/static/media/vertical-dot.5fe9a677.svg","height":32,"width":22,"blurWidth":0,"blurHeight":0};